import { IInquiriesSearchProps } from '@interfaces/inquiries';

export const buildInquiryListPayload = ({ isComplete, page }: IInquiriesSearchProps) => ({
  pagedResultsRequest: {
    pagination: {
      page,
      pageSize: Number(process.env.REACT_APP_PAGE_SIZE_FOR_USER_INQUIRIES_TABLE) || 5,
    },
    search: '',
    sort: {
      active: 'lastModifiedOn',
      direction: 'desc',
    },
  },
  isCompleted: isComplete,
});
